import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeCategoryPositionContext,
	IChangeCategoryPositionContext,
} from '../../../changeCategoryPositionState/changeCategoryPositionContext';
import { useHistory } from 'react-router-dom';
import { updateCategoryPositionsV2 } from 'backend/categories';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		changeTypeOfModalWindow,
		typeOfModalWindow,
		positionsData,
		selectedRestaurant,
		selectedAdditionalRestaurants,
	} = useContext<IChangeCategoryPositionContext>(ChangeCategoryPositionContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const restaurantsToApplyChanges = selectedRestaurant ? [selectedRestaurant, ...selectedAdditionalRestaurants] : [];

	const handleRedirect = () => {
		history.push('/menu-v2/category');
	};

	const handleConfirm = async () => {
		if (positionsData && selectedRestaurant) {
			try {
				const restaurantIds = [selectedRestaurant.id, ...selectedAdditionalRestaurants.map((el) => el.id)];
				const categoryIds = positionsData.map((el) => el.id);
				showLoader();
				await updateCategoryPositionsV2({
					restaurantIds,
					categoryIds,
				});
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={handleRedirect}
					onFailureEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSave' && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="saveChangeOnRestaurants"
					typeOfInfoIcon="withoutIcon"
					additionalContent={
						!!restaurantsToApplyChanges?.length && (
							<div className={style.itemsList}>
								{restaurantsToApplyChanges.map((el) => (
									<Text
										key={el.id}
										translationKey={el.name}
										theme="secondaryLight"
										size="l"
										weight="bold"
									/>
								))}
							</div>
						)
					}
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="errorWhileSaving"
				/>
			)}
		</div>
	);
};
